import { tables_2025_10_01 } from "./tables-2025-10-01.js";
import type { FhbRuleSet } from "./types.js";

// first-home-scheme ruleset — rule period from 1 JULY 2026.
//
// The ONLY change vs the 1-Oct-2025 period is the QLD FHOG SUNSET: the temporary
// $30,000 boost applied to contracts signed 20 Nov 2023 – 30 Jun 2026; for
// contracts signed AFTER 30 Jun 2026 the grant reverts to its legislated default
// of $15,000.  [figure-ledger #4 — CITED, QRO: "$30,000 for contracts signed
// between 20 November 2023 and 30 June 2026"; $15,000 is the underlying default.]
//
// Authored as a NEW dated period (never a mutation of the shipped one) so a
// historical assessment for a contract dated on/before 30 Jun 2026 still resolves
// $30k, and one dated 1 Jul 2026+ resolves $15k. Everything else (the 5% scheme,
// FHSS, NSW/VIC FHOG, all duty tables) is inherited unchanged.

export const tables_2026_07_01: FhbRuleSet = {
  ...tables_2025_10_01,
  periodKey: "2026-07-01",
  periodLabel: "from 1 July 2026 (QLD FHOG reverts to $15k)",
  effectiveFrom: "2026-07-01",
  effectiveTo: null,
  fhog: {
    ...tables_2025_10_01.fhog,
    // QLD FHOG sunset: $30k boost expires; reverts to the $15k default.
    QLD: {
      ...tables_2025_10_01.fhog.QLD,
      amount: 15_000,
    },
  },
};
